import { useQuery } from 'react-query'
import { ClimaProgramService } from '~/api/services/climaProgram'
import { onError } from '~/utils/helpers'

const getClimaRegOptionsData = () => useQuery(
  'clima-program-registrations-data',
  () => ClimaProgramService.getClimaRegOptionsData(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getAcceptTermsFile = () => useQuery(
  'clima-program-accept-terms-file',
  () => ClimaProgramService.getAcceptTermsFile(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getPurchasesOptionsData = () => useQuery(
  'clima-program-purchases-options-data',
  () => ClimaProgramService.getPurchasesOptionsData(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getPurchases = (data) => useQuery(
  'clima-program-purchases',
  () => ClimaProgramService.getPurchases(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getClimaRegistrationFile = (id) => useQuery(
  'manager-clima-registrations-file',
  () => id && ClimaProgramService.getClimaRegistrationFile(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data?.data
    }
  }
)

const showPurchase = (id) => useQuery(
  ['clima-program-purchase-view', id],
  () => id && ClimaProgramService.showPurchase(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getPurchasesIndexData = () => useQuery(
  'clima-program-purchases-index-data',
  () => ClimaProgramService.getPurchasesIndexData(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getClimaRegistrationsIndex = (data) => useQuery(
  'clima-program-registrations-list',
  () => ClimaProgramService.getClimaRegistrationsIndex(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getClimaRegistrationShow = (id) => useQuery(
  ['clima-program-register-show-view', id],
  () => id && ClimaProgramService.getClimaRegistrationShow(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

export const ClimaProgramQuery = {
  getClimaRegOptionsData,
  getAcceptTermsFile,
  getPurchasesOptionsData,
  showPurchase,
  getPurchases,
  getClimaRegistrationFile,
  getPurchasesIndexData,
  getClimaRegistrationsIndex,
  getClimaRegistrationShow
}